<script>
export default {
  name: 'DropdownNavigation',
  components: {},
  data() {
    return {
      dropdown: false,
      isVisible: false,
    };
  },
  methods: {
    toggleVisibility() {
      this.isVisible = !this.isVisible;
    },
  },
  computed: {},
};
</script>

<template>
  <li
    tabindex="0"
    class="dropdown__button"
    @mouseenter="isVisible = true"
    @click="toggleVisibility"
    @keydown.down="toggleVisibility"
  >
    {{ $t('navigation.rooms') }}
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.12016 1.29007L6.00016 5.17007L9.88016 1.29007C9.97274 1.19749 10.0827 1.12405 10.2036 1.07394C10.3246 1.02384 10.4542 0.998047 10.5852 0.998047C10.7161 0.998047 10.8457 1.02384 10.9667 1.07394C11.0877 1.12405 11.1976 1.19749 11.2902 1.29007C11.3827 1.38265 11.4562 1.49256 11.5063 1.61352C11.5564 1.73449 11.5822 1.86414 11.5822 1.99507C11.5822 2.126 11.5564 2.25565 11.5063 2.37661C11.4562 2.49757 11.3827 2.60749 11.2902 2.70007L6.70016 7.29007C6.60765 7.38277 6.49776 7.45632 6.37678 7.5065C6.25581 7.55668 6.12613 7.58251 5.99516 7.58251C5.86419 7.58251 5.73451 7.55668 5.61353 7.5065C5.49256 7.45632 5.38267 7.38277 5.29016 7.29007L0.700159 2.70007C0.607455 2.60755 0.533907 2.49767 0.483726 2.37669C0.433545 2.25572 0.407715 2.12604 0.407715 1.99507C0.407715 1.8641 0.433545 1.73442 0.483726 1.61344C0.533907 1.49247 0.607455 1.38258 0.700159 1.29007C1.09016 0.910068 1.73016 0.900068 2.12016 1.29007Z"
        fill="#DDE4F8"
      />
    </svg>
    <transition name="dropdown-fade">
      <ul class="dropdown__list" @mouseleave="isVisible = false" v-show="isVisible">
        <li class="item">
          <router-link to="/rodia">Rodia</router-link>
        </li>
        <li class="item"><router-link to="/elia">elia</router-link></li>
        <li class="item"><router-link to="/myrtia">Myrtia</router-link></li>
      </ul>
    </transition>
  </li>
</template>

<style scoped lang="scss">
.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: all 0.2s ease-in-out;
}
.dropdown-fade-enter,
.dropdown-fade-leave-active {
  opacity: 0;
  transform: translateY(-12px);
}

.dropdown__button {
  height: 100%;
  padding: 0px var(--size-4-3);
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  font-family: var(--ff-serif);
  font-style: normal;
  font-weight: 400;
  font-size: var(--fs-4-3);
  line-height: 22px;
  letter-spacing: 1px;
  text-transform: uppercase;

  color: hsl(var(--clr-primary-100));
  background-color: hsl(var(--clr-primary-700));
  cursor: pointer;
}

.dropdown__list {
  z-index: 10000;
  position: absolute;
  top: var(--size-9-8);
  left: 0;
  width: 100%;

  padding: 12px 0;

  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: hsl(var(--clr-primary-700));
}

.item {
  padding: var(--size-5) var(--size-4);
  border-bottom: 3px solid transparent;

  a {
    font-family: var(--ff-serif);
    font-style: normal;
    font-weight: 400;
    font-size: var(--fs-5-3);
    line-height: 22px;
    letter-spacing: 1px;
    text-transform: uppercase;

    color: hsl(var(--clr-primary-100));
  }
}

.item:hover,
.item:focus-within {
  border-bottom: 3px solid hsl(var(--clr-primary-500));
}
</style>
